import { safeJsonParse, toArray } from "@/utils/safeJson";

type PropostaCriacaoItem = {
  valor?: string | number;
  quantidade?: string | number;
  valor_total?: string | number;
};

function parseMoneyValue(value: unknown): number {
  if (value === null || value === undefined || value === "") return 0;
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;

  const moneyString = String(value).replace(/[^\d,.-]/g, "");
  if (!moneyString) return 0;

  const lastComma = moneyString.lastIndexOf(",");
  const lastDot = moneyString.lastIndexOf(".");
  const normalizedValue =
    lastComma > lastDot
      ? moneyString.replace(/\./g, "").replace(",", ".")
      : moneyString.replace(/,/g, "");
  const parsedValue = Number(normalizedValue);

  return Number.isFinite(parsedValue) ? parsedValue : 0;
}

export function calcularTotalPropostaCriacao(
  proposta: unknown,
): number {
  const propostaArray = safeJsonParse<PropostaCriacaoItem[]>(proposta, []);

  return toArray<PropostaCriacaoItem>(propostaArray).reduce((soma, item) => {
    if (
      item?.valor_total !== undefined &&
      item?.valor_total !== null &&
      item?.valor_total !== ""
    ) {
      return soma + parseMoneyValue(item.valor_total);
    }

    return (
      soma + parseMoneyValue(item?.valor) * parseMoneyValue(item?.quantidade)
    );
  }, 0);
}
